import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedComponentsModule } from '../shared-components.module';
import { NgStringPipesModule } from 'ngx-pipes';
import { MomentModule } from 'ngx-moment';
import { NgxGalleryModule } from '@app-components/ngx-gallery-video/ngx-gallery.module';
import { SavedSearchesComponent } from './saved-searches/saved-searches.component';
import { ClipboardModule } from 'ngx-clipboard';
import { CastOffVehiclesSummaryComponent } from './cast-off-vehicles/summary/cast-off-vehicles-summary.component';
import { DashFipeModule } from '@app-components/dash-fipe/dash-fipe.module';
import { CastOffHomeComponent } from './cast-off-home/cast-off-home.component';

const components = [
  SavedSearchesComponent,
  CastOffVehiclesSummaryComponent,
  CastOffHomeComponent,
];

@NgModule({
  declarations: components,
  exports: components,
  imports: [
    RouterModule,
    CommonModule,
    MatInputModule,
    MatIconModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatTooltipModule,
    CurrencyMaskModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxPaginationModule,
    SharedComponentsModule,
    NgStringPipesModule,
    MomentModule,
    NgxGalleryModule,
    ClipboardModule,
    DashFipeModule,
    MatProgressSpinnerModule,
  ]
})
export class VehiclesPagesModule { }
